const createWidgetFactory = require('components-framework/widget/create_widget_factory');
const isMobile = Odigeo.SessionScope.flow === 'mobile';

module.exports = createWidgetFactory({
    name: 'baggage_wrapper',
    viewClass: isMobile ? require('./view.mobile') : require('./view.desktop'),
    modelClass: require('./model'),
    methods: {
        evenUpSelection() {
            this.evenUpSelection.apply(this, arguments);
        },
        getTrackingData(event) {
            return this.getTrackingData(event);
        },
    },
});
